export const mobileTopBarHeight = 72
export const temporaryNavDrawer = {
  rightSideBar: {
    width: 240,
  },
}
